import { array } from '@ember/helper';
import { t } from 'ember-intl';
import { eq, and } from 'ember-truth-helpers';
import {
  HdsIconTile,
  HdsBadge,
  HdsLinkStandalone,
} from '@hashicorp/design-system-components/components';
import { boxMargin } from 'core/modifiers';
import Card from 'hcp/components/page/projects/dashboard/card';

const ResourceCard = <template>
  <Card data-test-resource-summary>
    <:header>
      <HdsIconTile @icon="cloud" />
      <h2 class="hds-typography-display-400">
        {{t "service-card.resource.title"}}
      </h2>
    </:header>
    <:body>
      {{#let (eq @resourceCount 0) as |hasNoResources|}}
        <HdsBadge
          @text={{if
            hasNoResources
            (t "service-card.resource.badge.inactive")
            (t "service-card.resource.badge.active" count=@resourceCount)
          }}
          @color={{if hasNoResources "neutral" "success"}}
          @icon={{if hasNoResources "hexagon" "check-circle"}}
          @size="large"
          {{boxMargin "0 0 xs 0"}}
        />
        <p
          class="hds-typography-body-200 body-text-color projectsDashboard__resourcesBody"
        >
          {{#if hasNoResources}}
            {{t "service-card.resource.body.inactive"}}
          {{else}}
            {{t "service-card.resource.body.active" count=@resourceCount}}
          {{/if}}
        </p>
      {{/let}}
    </:body>
    <:footer>
      {{#if (and @organization.id @project.id)}}
        <HdsLinkStandalone
          @icon="arrow-right"
          @iconPosition="trailing"
          @models={{array @organization.id @project.id}}
          @route="cloud.orgs.detail.projects.detail.active-resources"
          @text={{t "service-card.resource.link"}}
          data-test-resource-summary-link
        />
      {{/if}}
    </:footer>
  </Card>
</template>;

export default ResourceCard;
